// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction
import { cart, navigate } from "wix-stores-frontend";
import wixLocationFrontend from "wix-location-frontend";
import { formFactor } from "wix-window-frontend";
import * as constants from "public/constant.js"
import wixData from 'wix-data';
let idproduct = ""
$w.onReady(async function () {
    let jumpsuits = false;
    let tops = false;
    let coordset = false
    let product = await $w('#productPage1').getProduct();
    console.log("product", product);
    let results = await wixData.query("ProductsDatabase").eq("productReference", product._id).include("neckline").include("tops").include("sleeves").include("bottoms").find()
    console.log("results", results);
    let collections = await wixData.queryReferenced("Stores/Products", product._id, "collections");
    console.log("collections", collections);
    collections.items.forEach((i) => {
        if (i._id === constants.product_jumpsuits) {
            console.log("condiotion met");
            jumpsuits = true
        }
        if (i._id === constants.product_coordSets) {
            coordset = true
        }
        if (i._id === constants.product_tops) {
            tops = true
        }
    })
    console.log("jumpsuits", jumpsuits, "tops", tops);

    if (jumpsuits) {
        $w("#topDropdown").disable()
        $w("#bottomSizeDropdown").disable();
        $w("#bottomSizeDropdown").value = "XS"
    } else if (tops) {

        $w("#bottomDropdown").value = "D) Straight";
        $w("#bottomDropdown").disable();
        $w("#bottomSizeDropdown").value = "XS"
        $w("#bottomSizeDropdown").disable();

    }

    if (results.items.length > 0) {
        $w("#neckImage").src = results.items[0].neckline.imageconfigurator //neckline
        $w("#neckImage").alt = results.items[0].neckline.name //neckline
        $w("#bottomsImage").src = results.items[0].bottoms.imageconfigurator //bottom
        $w("#bottomsImage").alt = results.items[0].bottoms.name //bottom
        $w("#topImage").src = results.items[0].tops.imageconfigurator //top
        $w("#topImage").alt = results.items[0].tops.name //top
        $w("#sleevesImage").src = results.items[0].sleeves.imageconfigurator //sleeve
        $w("#sleevesImage").alt = results.items[0].sleeves.name //sleeve
        console.log("number", results.items[0].tops.number - 1);
        $w("#topDropdown").selectedIndex = results.items[0].tops.number - 1
        $w("#bottomDropdown").selectedIndex = results.items[0].bottoms.number - 1
        $w("#necklineDropdown").selectedIndex = results.items[0].neckline.number - 1
        $w("#sleeveDropdown").selectedIndex = results.items[0].sleeves.number - 1
        idproduct = product._id
    } else {
        $w("#viewCombinationsBtn").hide();
    }

    $w("#button15").onClick(() => {
        console.log("clicked");
        console.log("idproduct", idproduct);
        if ($w('#necklineDropdown').value !== '' && $w('#sleeveDropdown').value !== '' && $w('#topDropdown').value !== '' && $w('#bottomDropdown').value !== '' && $w('#topSizeDropdown').value !== '' && $w("#bottomSizeDropdown").value !== '') {
            const products = [{
                "productId": idproduct,
                "quantity": 1,
                "options": {
                    // "choices": {
                    //     //"Size": $w('#topSizeDropdown').value
                    //     "Bottom Size": $w('#topSizeDropdown').value,
                    //     "Top Size": $w('#bottomSizeDropdown').value
                    // },
                    "customTextFields": [{
                            "title": "Neckline",
                            "value": $w("#neckImage").alt
                        },
                        {
                            "title": "Sleeve",
                            "value": $w("#sleevesImage").alt
                        },
                        {
                            "title": "Top Pattern",
                            "value": $w("#topImage").alt
                        },
                        {
                            "title": "Bottom",
                            "value": $w("#bottomsImage").alt
                        }
                    ]
                }
            }]
            console.log("products", products);

            if (product?.productOptions?.Size) {
                console.log("choices present");
                console.log("drop 7 val", $w("#topSizeDropdown").value);
                if ($w("#topSizeDropdown").value != '') {
                    products[0].options.choices = {
                        "Size": $w("#topSizeDropdown").value
                    }
                } else {
                    $w("#topSizeDropdown").focus();
                    return;
                }
            } else {
                console.log("NOT Present!!");
                if ($w("#bottomSizeDropdown").value !== '' && $w("#topSizeDropdown").value !== '') {
                    products[0].options.choices = {
                        "Top Size": $w("#bottomSizeDropdown").value,
                        "Bottom Size": $w("#topSizeDropdown").value,
                    }
                    products[0].options.customTextFields.push({ "title": "Top Size", "value": $w("#topSizeDropdown").value })
                    products[0].options.customTextFields.push({ "title": "Bottom Size", "value": $w("#bottomSizeDropdown").value });

                    console.log("products", products);
                } else if ($w('#topSizeDropdown').value === '') {
                    $w('#topSizeDropdown').focus();
                } else if ($w('#bottomSizeDropdown').value === '') {
                    $w('#bottomSizeDropdown').focus();
                }
            }

            cart.addProducts(products)
                .then((updatedCart) => {
                    // Products added to cart
                    console.log("updatedCart", updatedCart);
                    const cartId = updatedCart._id;
                    const cartLineItems = updatedCart.lineItems;
                    if (formFactor !== "Mobile") {
                        cart.showMiniCart();
                    } else {
                        navigate.toCart();
                    }
                    //$w('#text40').show();
                })
                .catch((error) => {
                    console.log(error);
                });
        } else if ($w('#necklineDropdown').value === '') {
            $w('#necklineDropdown').focus();
            //$w('#text41').show();
        } else if ($w('#sleeveDropdown').value === '') {
            $w('#sleeveDropdown').focus();
            //$w('#text42').show();
        } else if ($w('#topDropdown').value === '') {
            $w('#topDropdown').focus();
            //$w('#text43').show();
        } else if ($w('#bottomDropdown').value === '') {
            $w('#bottomDropdown').focus();
            //$w('#text44').show();
        } else if ($w('#topSizeDropdown').value === '') {
            $w('#topSizeDropdown').focus();
            //$w('#text45').show();
        } else if ($w('#bottomSizeDropdown').value === '') {
            $w('#bottomSizeDropdown').focus();
            //$w('#text45').show();
        }

    })
    $w("#clearBtn").onClick(() => {
        $w('#topImage').hide()
        $w('#bottomsImage').hide()
        $w('#sleevesImage').hide()
        $w('#neckImage').hide();
        $w("#necklineDropdown").selectedIndex = null
        $w("#sleeveDropdown").selectedIndex = null
        $w("#topDropdown").selectedIndex = null
        $w("#bottomDropdown").selectedIndex = null
        $w("#topSizeDropdown").selectedIndex = null
        $w("#bottomSizeDropdown").selectedIndex = null
    })
    $w("#topDropdown").onChange(async (e) => {
        console.log("change", e);
        $w('#topImage').show()
        let imgSrc = await designChange("Tops", e.target.value);
        console.log("imgSrc", imgSrc);
        $w("#topImage").src = imgSrc[0]
        $w("#topImage").alt = imgSrc[1]
    })

    $w("#bottomDropdown").onChange(async (e) => {
        console.log("change", e);
        $w("#bottomsImage").show()
        let imgSrc = await designChange("Bottoms", e.target.value);
        console.log("imgSrc", imgSrc);
        $w("#bottomsImage").src = imgSrc[0]
        $w("#bottomsImage").alt = imgSrc[1]
    })
    $w("#sleeveDropdown").onChange(async (e) => {
        console.log("change", e);
        let imgSrc = await designChange("Sleeves", e.target.value)
        console.log("imgSrc", imgSrc);
        if (imgSrc[0] === undefined) {
            $w("#sleevesImage").hide()
            $w("#sleevesImage").alt = imgSrc[1]
        } else {
            $w("#sleevesImage").show()
            $w("#sleevesImage").src = imgSrc[0]
            $w("#sleevesImage").alt = imgSrc[1]
        }
    })
    $w("#necklineDropdown").onChange(async (e) => {
        console.log("change", e);
        $w("#neckImage").show()
        let imgSrc = await designChange("NecklinePatterns", e.target.value);
        console.log("imgSrc", imgSrc);
        $w("#neckImage").src = imgSrc[0]
        $w("#neckImage").alt = imgSrc[1]
    })

    $w("#viewCombinationsBtn").onClick(() => {
        if ($w("#section32").collapsed) {
            $w("#section32").expand();
        } else {
            $w("#section32").collapse();
        }

    })
    $w("#buyNow").onClick(() => {
        if ($w('#necklineDropdown').value !== '' && $w('#sleeveDropdown').value !== '' && $w('#topDropdown').value !== '' && $w('#bottomDropdown').value !== '' && $w('#topSizeDropdown').value !== '' && $w("#bottomSizeDropdown").value !== '') {
            const products = [{
                "productId": idproduct,
                "quantity": 1,
                "options": {
                    // "choices": {
                    //     "Bottom Size": $w('#topSizeDropdown').value,
                    //     "Top Size": $w('#bottomSizeDropdown').value
                    // },
                    "customTextFields": [{
                            "title": "Neckline",
                            "value": $w("#neckImage").alt
                        },
                        {
                            "title": "Sleeve",
                            "value": $w("#sleevesImage").alt
                        },
                        {
                            "title": "Top Pattern",
                            "value": $w("#topImage").alt
                        },
                        {
                            "title": "Bottom",
                            "value": $w("#topImage").alt
                        },
                        // {
                        //     "title": "Bottom Size",
                        //     "value": $w("#dropdown4").value
                        // }
                    ]
                }
            }]
            console.log("products", products);

            if (product?.productOptions?.Size) {
                console.log("choices present");
                console.log("drop 7 val", $w("#topSizeDropdown").value);
                if ($w("#topSizeDropdown").value != '') {
                    products[0].options.choices = {
                        "Size": $w("#topSizeDropdown").value
                    }
                } else {
                    $w("#topSizeDropdown").focus();
                    return;
                }
            } else {
                console.log("NOT Present!!");
                if ($w("#bottomSizeDropdown").value !== '' && $w("#topSizeDropdown").value !== '') {
                    products[0].options.choices = {
                        "Top Size": $w("#bottomSizeDropdown").value,
                        "Bottom Size": $w("#topSizeDropdown").value,
                    }
                    products[0].options.customTextFields.push({ "title": "Top Size", "value": $w("#topSizeDropdown").value })
                    products[0].options.customTextFields.push({ "title": "Bottom Size", "value": $w("#bottomSizeDropdown").value });

                    console.log("products", products);
                } else if ($w('#topSizeDropdown').value === '') {
                    $w('#topSizeDropdown').focus();
                } else if ($w('#bottomSizeDropdown').value === '') {
                    $w('#bottomSizeDropdown').focus();
                }
            }

            cart.addProducts(products)
                .then((updatedCart) => {
                    // Products added to cart
                    console.log("updatedCart", updatedCart);
                    const cartId = updatedCart._id;
                    const cartLineItems = updatedCart.lineItems;
                    navigate.toCart();
                    //$w('#text40').show();
                })
                .catch((error) => {
                    console.log(error);
                });
        } else if ($w('#necklineDropdown').value === '') {
            $w('#necklineDropdown').focus();
            //$w('#text41').show();
        } else if ($w('#sleeveDropdown').value === '') {
            $w('#sleeveDropdown').focus();
            //$w('#text42').show();
        } else if ($w('#topDropdown').value === '') {
            $w('#topDropdown').focus();
            //$w('#text43').show();
        } else if ($w('#bottomDropdown').value === '') {
            $w('#bottomDropdown').focus();
            //$w('#text44').show();
        } else if ($w('#topSizeDropdown').value === '') {
            $w('#topSizeDropdown').focus();
            //$w('#text45').show();
        } else if ($w('#bottomSizeDropdown').value === '') {
            $w('#bottomSizeDropdown').focus();
            //$w('#text45').show();
        }
    })

});

//I) Collar (Shirt)
async function designChange(collectionName, value) {
    let results = await wixData.query(collectionName).eq("name", value).find();
    console.log("results", results.items);

    if ($w("#necklineDropdown").value === "J) Off-shoulder" || $w("#necklineDropdown").value === "K) Tube" || $w("#necklineDropdown").value === "L) Sweet heart" || $w("#necklineDropdown").value === "M) Halter" || $w("#necklineDropdown").value === "N) Spaghetti") {
        $w("#sleeveDropdown").value = "A) Sleeveless"
        $w("#sleevesImage").hide()
        $w("#dataset3").setFilter(
            wixData.filter().eq("name", "A) Sleeveless")
        )
    }
    // else if ($w("#necklineDropdown").value !== "J) Off-shoulder" || $w("#necklineDropdown").value !== "K) Tube" || $w("#necklineDropdown").value !== "L) Sweet heart" || $w("#necklineDropdown").value !== "M) Halter" || $w("#necklineDropdown").value !== "N) Spaghetti") {
    //     $w("#dataset3").setFilter(wixData.filter());
    // } 
    else {
        $w("#dataset3").setFilter(wixData.filter());
    }

    if ($w("#necklineDropdown").value === "I) Collar (Shirt)") {
        $w("#dataset5").setFilter(
            wixData.filter().eq("name", "E) Shirt")
        )
        $w("#topDropdown").value = "E) Shirt"
    } else {
        $w("#dataset5").setFilter(wixData.filter());
    }

    let imgSrc = results.items[0].imageconfigurator
    return [imgSrc, results.items[0].name];
}